module.exports = __webpack_public_path__ + "static/img/gongye1.757fdb5c.png";